import { ListBoxItem } from 'react-aria-components';
import type { ListBoxItemProps } from 'react-aria-components';



export const SelectItem = (props: ListBoxItemProps) => {

	return (
		<ListBoxItem {...props} />
	)
}

export default SelectItem;